import actions from './actionTypes';
import * as api from '../services/api';
import { fabric } from 'fabric';
import * as Constants from '../utilities/constants/Constants';
import { Placing, copyPlaceable } from './ProjectData/Placing';
import {
  addBackgroundElement,
  addTileBackground,
  selectObject,
  setWebLinkSaveIdentifier,
  updateTextLoaderCoordinates,
  getDefaultTileSize,
  addSolidColorToCanvas,
  clearCanvas,
  getElementImagePath,
  sampleModelSize,
  isPlaceablePresentInInspiration,
  handleRotation,
  canvasSizeWithPadding,
  clearUndoInstance,
  removeElement,
  setScenePlacingOffsetAndSize,
  makeProjectDirtyWithNoUndoSupport
} from './fabricCanvasActions';
import {
  getPrintersDetails,
  handleAddPrinterWindow
} from './vanillaDesignActions';
import { string } from '../localization';
import { checkIfCanvasApp } from './homeActions';
import {
  updateWindowDimensions,
  showHelperWindow
} from './fabricCanvasActions';
import {
  patternDesignCost,
  getDreamstimePrice,
  getFirstTheme,
  getSelectedFont,
  getTextFonts
} from './sideBarActions';
import {
  addCanvasObjectOnCreation,
  minimumViewingDistanceIsUpdated
} from './fabricCanvasActions';
import { changeObjectBorderColor } from './fabricCanvasActions';
import { setLoadingState } from './fabricCanvasActions';
import {
  uniqueArray,
  shouldSelectFirstSceneOfFirstTheme,
  isLaunchToCheckoutEnabled,
  isLaunchToProcessingPageEnabled,
  convertFromCamelCase,
  checkForMultilineText,
  isStartUpScene,
  isARCEnabled,
  getActiveCanvas,
  isSignageSuiteProduct
} from '../utilities/HelperFunctions/HelperFunctions';
import { emailPreviewWithLoupeRecipients } from '../services/apiHelpers';
import { emailRecipientsWithMessageAboutProjectLinkType } from '../services/apiHelpers';
import { isElementRecolorable } from '../Containers/Toolbar/ToolbarValidations';
import * as CookieUtils from '../utilities/CookieUtils/CookieUtils';
import {
  setExternalContentResourcePrefix,
  setNoContentResourcePrefix,
  setInternalContentResourcePrefix,
  createResponseObject
} from './modalActions';
import { updateFinalCheckWithData } from './finalCheckActions';
import { setCurrentPageIndex } from './pageControllerActions';
import {
  sendDesignPageGAEvents,
  sendLoginGAEvents,
  gaOfSelectingInspiration
} from '../utilities/GAHelpers/GAHelpers';
import {
  generatePreviewsOfSideWalls,
  getContainerWidth,
  getMultiProjectsWidth,
  getSharedScenePlacingSizeAndOffset,
  isSharedScene
} from './actions/multiWallHandler';
import { refresh3D } from './fabricCanvasActions';
import { getPlacings } from './ProjectData/Project';
import { checkForPixelationWarning } from './actions/pixelationHandler';
import {
  saveOnlyIfDirtyAndCall,
  saveProjectAndCall
} from './projectSaveAndLoader';
import { sizeSettingsAreChanged } from './actions/sizeHandler';

const editOrAddText = (isTextEdit, canvas, textImageObject, oldText) => {
  const textPlacing = textImageObject.placing;
  if (isTextEdit || textPlacing.isDuplicate) {
    textPlacing.flipX = oldText.placing.flipX;
    textPlacing.opacity = oldText.placing.opacity;

    textImageObject.flipX = textPlacing.flipX;
    textImageObject.opacity = textPlacing.opacity ? textPlacing.opacity : 1;
    textImageObject.angle = oldText.angle;

    // Need optimization : Calculate from placing level
    const oldTextScaleValues = calculateScaleForTextOrWatermark(
      oldText,
      canvas
    );
    const oldTextScaleXRatio = oldText.scaleX / oldTextScaleValues[0];

    const newTextScaleX = textImageObject.scaleX * oldTextScaleXRatio;

    textImageObject.scale(newTextScaleX).setCoords();
    // Maintain minimum size for text as 20 pixels.
    if (
      textImageObject.getScaledWidth() <= 20 ||
      textImageObject.getScaledHeight() <= 20
    ) {
      const minimumScale = 20 / textImageObject.height;
      textImageObject.scale(minimumScale).setCoords();
    }

    if (isTextEdit) {
      let newLeft = oldText.left;
      let newTop = oldText.top;
      if (
        Object.prototype.hasOwnProperty.call(oldText, 'placing') &&
        oldText.placing.placeable.text != textPlacing.placeable.text
      ) {
        if (oldText.left + textImageObject.getScaledWidth() > canvas.width) {
          const extraWidth =
            oldText.left + textImageObject.getScaledWidth() - canvas.width;
          newLeft = oldText.left - extraWidth;
        }
        if (oldText.top + textImageObject.getScaledHeight() > canvas.height) {
          const extraHeight =
            oldText.top + textImageObject.getScaledHeight() - canvas.height;
          newTop = oldText.top - extraHeight;
        }
      }
      textImageObject.set({
        top: newTop,
        left: newLeft
      });
    } else {
      textImageObject.set({
        top: oldText.top + 20,
        left: oldText.left + 20
      });
    }
  } else {
    // Position it to center only  when it is new watermark
    canvas.viewportCenterObject(textImageObject);
  }
};

export const calculateScaleForTextOrWatermark = (img, canvas) => {
  const elementWidth = img.width;
  const elementHeight = img.height;

  const shortProjectDimension = Math.min(canvas.height, canvas.width);
  const normalizeRatio = shortProjectDimension / (240 / 2.54);
  const placeableHeight = 18.0;
  const placableWidth = (placeableHeight * elementWidth) / elementHeight;
  const normalizedWidth = placableWidth * normalizeRatio;
  const normalizedHeight = placeableHeight * normalizeRatio;

  let normalizedScaleX = normalizedWidth / elementWidth;
  let normalizedScaleY = normalizedHeight / elementHeight;

  if (normalizedWidth > canvas.width) {
    normalizedScaleX = canvas.width / elementWidth;
    const newWidth = normalizedScaleX * elementWidth;
    const newHeight = newWidth * (elementHeight / elementWidth);
    normalizedScaleY = newHeight / elementHeight;
  }
  if (normalizedHeight > canvas.height) {
    normalizedScaleY = canvas.height / elementHeight;
    const newHeight = normalizedScaleY * elementHeight;
    const newWidth = newHeight * (elementWidth / elementHeight);
    normalizedScaleX = newWidth / elementWidth;
  }
  return [normalizedScaleX, normalizedScaleY];
};

export const textImageIsGenerated = (
  placing,
  isInspirationPlacing,
  callback
) => dispatch => {
  fabric.Image.fromURL(placing.placeable.imagePath, img => {
    img.placing = placing;
    dispatch(continueAddTextToCanvas(img, isInspirationPlacing, callback));
  });
};

export const generateSVGImage = (
  placing,
  isInspirationPlacing,
  callback
) => dispatch => {
  const TextToSVG = require('text-to-svg');
  const fontPath = dispatch(getSelectedFont(placing.placeable.fontId))
    .font_file_url;

  TextToSVG.load(fontPath, (err, textToSVG) => {
    const hexValue = `#${placing.placeable.rgb}`;
    const options = {
      x: 0,
      y: 0,
      fontSize: 72,
      anchor: placing.placeable.textAnchor,
      attributes: { fill: hexValue }
    };
    const str = placing.placeable.text;
    const svg = textToSVG.getSVG(str, options);

    fabric.loadSVGFromString(svg, (objects, svgOptions) => {
      const obj = fabric.util.groupSVGElements(objects, svgOptions);
      obj.placing = placing;
      dispatch(continueAddTextToCanvas(obj, isInspirationPlacing, callback));
      dispatch(
        createText(placing, () => {
          dispatch(refresh3D());
        })
      );
    });
  });
};

export const createText = (placing, callback) => (dispatch, getState) => {
  const postData = {
    placeable: {
      id: placing.placeable.id,
      text_color: placing.placeable.rgb,
      text: placing.placeable.text,
      text_anchor: placing.placeable.textAnchor,
      font_id: placing.placeable.fontId,
      path: placing.placeable.textPath
    },
    require_web_image: true
  };
  if (placing.placeable.shadow) {
    postData.placeable.shadow = true;
    postData.placeable.shadow_color = placing.placeable.shadowColor;
  } else {
    postData.placeable.shadow = false;
  }

  if (placing.placeableId) {
    api.sendUpdateText(placing.placeableId, postData).then(postResponse => {
      const textObj = createResponseObject(
        [postResponse.data],
        Constants.TEXT_ELEMENT_TYPE
      )[0];
      placing.placeable = textObj;
      callback();
    });
  } else {
    api.sendAddText(postData).then(postResponse => {
      const textObj = createResponseObject(
        [postResponse.data],
        Constants.TEXT_ELEMENT_TYPE
      )[0];
      if (
        getState().fabricCanvas.activeObject &&
        getState().fabricCanvas.activeObject.placing === placing
      ) {
        dispatch({
          type: actions.SET_TEXT_ID,
          payload: {
            id: textObj.id
          }
        });
      }
      placing.placeable = textObj;
      placing.placeableId = textObj.id;
      callback();
    });
  }
};

export const addTextToCanvas = (placing, callback) => dispatch => {
  const isInspirationPlacing = dispatch(
    isPlaceablePresentInInspiration(placing.placeableId)
  );

  if (placing.placeableId && isInspirationPlacing) {
    placing.placeableId = null;
    placing.placeable.id = null;
  }

  dispatch(updateTextLoaderCoordinates());
  if (
    placing.placeable.shadow ||
    placing.placeable.textPath != 'line' ||
    checkForMultilineText(placing.placeable.text)
  ) {
    dispatch(
      createText(placing, () => {
        dispatch(textImageIsGenerated(placing, isInspirationPlacing, callback));
      })
    );
  } else {
    placing.placeable.text = placing.placeable.text.replace(/\n/g, '');
    dispatch(generateSVGImage(placing, isInspirationPlacing, callback));
  }
};

export const continueAddTextToCanvas = (
  object,
  isInspirationPlacing,
  callback
) => (dispatch, getState) => {
  const canvas = dispatch(getActiveCanvas(object.placing));
  const projectScale = getState().home.projectHeight / canvas.height;
  const scaleValues = calculateScaleForTextOrWatermark(object, canvas);
  let totalScaleX = scaleValues[0];
  let totalScaleY = scaleValues[1];
  if (object.placing.width && object.placing.height) {
    totalScaleX = object.placing.width / (object.width * projectScale);
    totalScaleY = object.placing.height / (object.height * projectScale);
  }
  object.set({
    scaleX: totalScaleX,
    scaleY: totalScaleY,
    angle: 0,
    flipX: object.placing.flipX,
    opacity: object.placing.opacity ? object.placing.opacity : 1,
    resizeType: 'proportionally',
    layer: Constants.LAYER_ID_ANNOTATION
  });
  changeObjectBorderColor(object, dispatch);
  let isTextEdit = false;
  if (object.placing.width && object.placing.height) {
    object.set({
      top: object.placing.yOffset / projectScale,
      left: object.placing.xOffset / projectScale
    });
  } else {
    const oldText = canvas.getActiveObject();
    const { project } = getState().finalCheck;
    const allPlacings = getPlacings(project);
    if (oldText && oldText.placing) {
      isTextEdit = allPlacings.indexOf(oldText.placing) == -1;
    }
    if (isTextEdit || isInspirationPlacing) {
      canvas.remove(canvas.getActiveObject());
    }
    editOrAddText(isTextEdit || isInspirationPlacing, canvas, object, oldText);
  }
  if (!(isTextEdit || isInspirationPlacing || object.placing.isDuplicate)) {
    dispatch(handleRotation(object, object.placing.angle, canvas));
  }
  dispatch(addCanvasObjectOnCreation(object, canvas));
  callback();
};

export const getScaleToFillCanvasFactorForScene = element => (
  dispatch,
  getState
) => {
  let viewScale = 1;
  const elementWidth = element.width;
  const elementHeight = element.height;
  const { projectHeight } = getState().home;
  const projectHeightWithPadding = projectHeight + dispatch(scenePadding());

  const canvasSize = dispatch(canvasSizeWithPadding());
  const projectHeightScale = projectHeightWithPadding / canvasSize.height;
  const containerWidth =
    dispatch(getContainerWidth()) +
    dispatch(scenePadding()) / projectHeightScale;

  if (containerWidth > canvasSize.height) {
    const widthScale = containerWidth / elementWidth;
    viewScale = widthScale;
    const newHeight = elementHeight * viewScale;
    if (newHeight < canvasSize.height) {
      viewScale *= canvasSize.height / newHeight;
    }
  } else {
    const heightScale = canvasSize.height / elementHeight;
    viewScale = heightScale;
    const newWidth = elementWidth * viewScale;
    if (newWidth < containerWidth) {
      viewScale *= containerWidth / newWidth;
    }
  }
  return viewScale;
};

export const getScaleToFillCanvasFactorForElement = (
  element,
  canvas
) => dispatch => {
  let viewScale = 1;
  const elementWidth = element.width; // (element.image_source === 'local') ? element.width : element.image_width;
  const elementHeight = element.height; // (element.image_source === 'local') ? element.height : element.image_height;
  const containerWidth = dispatch(getContainerWidth());
  if (containerWidth > canvas.height) {
    const widthScale = containerWidth / elementWidth;
    viewScale = widthScale;
    const newHeight = elementHeight * viewScale;
    if (newHeight < canvas.height) {
      viewScale *= canvas.height / newHeight;
    }
  } else {
    const heightScale = canvas.height / elementHeight;
    viewScale = heightScale;
    const newWidth = elementWidth * viewScale;
    if (newWidth < containerWidth) {
      viewScale *= containerWidth / newWidth;
    }
  }
  return viewScale;
};

function getCroppedImg(image, crop) {
  const canvas = document.createElement('canvas');
  const scaleX = image.naturalWidth / image.width;
  const scaleY = image.naturalHeight / image.height;
  canvas.width = crop.width;
  canvas.height = crop.height;
  const ctx = canvas.getContext('2d');

  ctx.drawImage(
    image,
    crop.x * scaleX,
    crop.y * scaleY,
    crop.width * scaleX,
    crop.height * scaleY,
    0,
    0,
    crop.width,
    crop.height
  );

  return canvas.toDataURL('image/png');
}

const generateCropImage = (image, crop) =>
  new Promise(resolve => {
    const cropImage = getCroppedImg(image, crop);
    resolve(cropImage);
  });

export const addBackgroundToCanvas = (
  placing,
  defaultScaleSliderValue,
  callback
) => dispatch => {
  const canvas = dispatch(getActiveCanvas(placing));
  const rect = new fabric.Rect({
    height: canvas.height,
    width: canvas.width,
    strokeWidth: 0,
    fill: 'rgba(166, 166, 166)',
    selectable: false,
    layer: Constants.LAYER_ID_BACKGROUND
  });
  canvas.add(rect);
  rect.moveTo(0);

  if (
    Object.prototype.hasOwnProperty.call(placing.placeable, 'imageSource') &&
    placing.placeable.imageSource === Constants.DREAMSTIME_IMAGE_SOURCE
  ) {
    const image = new Image();
    image.crossOrigin = 'Anonymous';
    image.src = placing.placeable.imagePath;
    image.onload = () => {
      generateCropImage(image, placing.placeable.crop).then(croppedImage => {
        placing.placeable.croppedImagePath = croppedImage; // Verify if imagePath is needed. If no remove this
        dispatch(
          continueAddBackgroundToCanvas(
            placing,
            rect,
            defaultScaleSliderValue,
            callback
          )
        );
      });
    };
  } else {
    dispatch(
      continueAddBackgroundToCanvas(
        placing,
        rect,
        defaultScaleSliderValue,
        callback
      )
    );
  }
};

const continueAddBackgroundToCanvas = (
  placing,
  rect,
  defaultScaleSliderValue,
  callback
) => (dispatch, getState) => {
  const { project } = getState().finalCheck;

  let imagePath = dispatch(getElementImagePath(placing));
  let placingValues = { ...placing };

  if (dispatch(isSharedScene())) {
    placingValues = dispatch(getSharedScenePlacingSizeAndOffset(project));
    imagePath = placingValues.imagePath;
  }
  fabric.Image.fromURL(imagePath, myImage => {
    const canvas = dispatch(getActiveCanvas(placing));
    const { projectWidth, projectHeight } = getState().home;
    const projectWidthWithPadding = projectWidth + dispatch(scenePadding());
    const projectHeightWithPadding = projectHeight + dispatch(scenePadding());

    const canvasSize = dispatch(canvasSizeWithPadding());
    const projectHeightScale = projectHeightWithPadding / canvasSize.height;
    const projectWidthScale = projectWidthWithPadding / canvasSize.width;

    const originalViewScale = dispatch(
      getScaleToFillCanvasFactorForScene(myImage)
    );
    let projectScale = projectWidthScale;
    if (originalViewScale * myImage.height == canvasSize.height) {
      projectScale = projectHeightScale;
    }

    // We need originalViewScale to calculate slider scale. ie.. image scaleX / originalViewScale will be slider scale.
    myImage.set({
      placing,
      flipX: placingValues.flipX,
      loadingRect: rect,
      top: 0,
      left: 0,
      layer: Constants.LAYER_ID_BACKGROUND
    });
    myImage.scale(originalViewScale).setCoords();

    let sliderUIValue = defaultScaleSliderValue;
    if (
      placingValues.width &&
      placingValues.height &&
      !dispatch(isSharedScene())
    ) {
      if (placing.tiled) {
        const tileDimension = dispatch(getDefaultTileSize(myImage));
        myImage.tiledDimensions = {
          width: tileDimension.width,
          height: tileDimension.height,
          scale: placingValues.width / tileDimension.width
        };
      } else {
        const totalScaleValue =
          placingValues.width / (myImage.width * projectScale);
        myImage.scale(totalScaleValue).setCoords();

        const sliderCalculatedValue = totalScaleValue / originalViewScale;
        sliderUIValue =
          ((sliderCalculatedValue - Constants.MINIMUM_ZOOM_VALUE) *
            Constants.SLIDER_MAX_VALUE) /
          (Constants.MAXIMUM_ZOOM_VALUE - Constants.SLIDER_MIN_VALUE);
        sliderUIValue = Math.abs(sliderUIValue.toFixed(2));
      }
      myImage
        .set({
          left: placingValues.xOffset / projectHeightScale,
          top: placingValues.yOffset / projectHeightScale
        })
        .setCoords();
    } else if (placingValues.width && placingValues.height) {
      const totalScaleValue =
        placingValues.width / (myImage.width * projectScale);
      myImage.scale(totalScaleValue).setCoords();
      myImage
        .set({
          left: placingValues.xOffset / projectHeightScale,
          top: placingValues.yOffset / projectHeightScale
        })
        .setCoords();
    }

    myImage.hasControls = false;
    myImage.hasBorders = false;
    myImage.scaleSliderValue = sliderUIValue;
    if (placing.tiled) {
      dispatch(addTileBackground(myImage, canvas, callback));
    } else {
      dispatch(addBackgroundElement(myImage, canvas));
      if (callback) {
        callback();
      }
    }
    dispatch(patternDesignCost(placing.placeable));
    dispatch(getDreamstimePrice(placing.placeable));
  });
};

export const scenePadding = () => (dispatch, getState) => {
  let extendedBufferSize = 0;
  const { partnerStoreType } = getState().modal.storeData;
  const { canvasFrameType, canvasFrameWidth } = getState().finalCheck.project;
  const projectCategory = getState().modal.envData.category;
  if (isSignageSuiteProduct()) {
    extendedBufferSize = Constants.TrimBufferSize;
  } else if (
    !isARCEnabled(projectCategory, partnerStoreType) &&
    dispatch(isPosterTypeProject())
  ) {
    extendedBufferSize =
      Constants.TrimBufferSize + Constants.RoundingErrorBufferSize;
  } else if (
    !isARCEnabled(projectCategory, partnerStoreType) &&
    (!dispatch(checkIfCanvasApp()) ||
      canvasFrameType == Constants.CANVAS_FRAME_TYPE_EXTEND)
  ) {
    extendedBufferSize = Constants.TrimBufferSize + Constants.BorderBufferSize;
  }
  if (canvasFrameType == Constants.CANVAS_FRAME_TYPE_EXTEND) {
    extendedBufferSize += canvasFrameWidth;
  }
  return extendedBufferSize * 2;
};

export const isPosterTypeProject = () => dispatch =>
  dispatch(isPoster()) || dispatch(isCommercialPosterTypeProject());

export const isCommercialPosterTypeProject = () => (dispatch, getState) => {
  const { category } = getState().modal.envData;
  return (
    category === Constants.COMMERCIAL_POSTER_CATEGORY ||
    category === Constants.NEW_POSTER_CATEGORY ||
    category === Constants.GIFTWRAPS_CATEGORY
  );
};

export const isCommercialPoster = () => (dispatch, getState) => {
  const { category } = getState().modal.envData;
  return category === Constants.COMMERCIAL_POSTER_CATEGORY;
};

export const isNewPosterCategory = () => (dispatch, getState) => {
  const { category } = getState().modal.envData;
  return category === Constants.NEW_POSTER_CATEGORY;
};

export const isPoster = () => (dispatch, getState) => {
  const { category } = getState().modal.envData;
  return category === Constants.POSTER_CATEGORY;
};

export const isPosterCategory = () => (dispatch, getState) => {
  const { category } = getState().modal.envData;
  return (
    category === Constants.COMMERCIAL_POSTER_CATEGORY ||
    category === Constants.NEW_POSTER_CATEGORY ||
    category === Constants.POSTER_CATEGORY
  );
};

export const addElementToCanvas = (
  placing,
  properties,
  callback
) => dispatch => {
  if (placing.imageSource === Constants.DREAMSTIME_IMAGE_SOURCE) {
    const image = new Image();
    image.crossOrigin = 'Anonymous';
    image.src = placing.placeable.imagePath;
    image.onload = () => {
      generateCropImage(image, placing.placeable.crop).then(croppedImage => {
        const { placeable } = placing;
        placeable.croppedImagePath = croppedImage;
        placeable.width = placeable.crop.width;
        placeable.height = placeable.crop.height;
        dispatch(continueAddElementToCanvas(placing, properties, callback));
      });
    };
  } else {
    dispatch(continueAddElementToCanvas(placing, properties, callback));
  }
};

const continueAddElementToCanvas = (placing, properties, callback) => (
  dispatch,
  getState
) => {
  const canvas = dispatch(getActiveCanvas(placing));
  const elementWidth = placing.placeable.width;
  const elementHeight = placing.placeable.height;

  const shortProjectDimension = Math.min(canvas.height, canvas.width);
  const normalizeRatio = shortProjectDimension / (240 / 2.54);
  const placeableHeight = 36;
  const placableWidth = (placeableHeight * elementWidth) / elementHeight;
  const normalizedWidth = placableWidth * normalizeRatio;
  const normalizedHeight = placeableHeight * normalizeRatio;

  let normalizedScaleX = normalizedWidth / elementWidth;
  let normalizedScaleY = normalizedHeight / elementHeight;

  if (normalizedWidth > canvas.width) {
    normalizedScaleX = canvas.width / elementWidth;
    normalizedScaleY = normalizedScaleX;
  }
  if (normalizedHeight > canvas.height) {
    normalizedScaleY = canvas.height / elementHeight;
    normalizedScaleX = normalizedScaleY;
  }

  const rect = new fabric.Rect({
    height: elementHeight,
    width: elementWidth,
    scaleX: normalizedScaleX,
    scaleY: normalizedScaleY,
    strokeWidth: 0,
    fill: 'rgba(178, 178, 178,0.3)',
    selectable: false,
    layer: Constants.LAYER_ID_ANNOTATION
  });
  canvas.viewportCenterObject(rect);
  canvas.add(rect);
  const normalizeValues = {
    x: normalizedScaleX,
    y: normalizedScaleY,
    width: normalizedWidth,
    height: normalizedHeight
  };

  const projectScale = getState().home.projectHeight / canvas.height;
  let rectTop = 0;
  let rectLeft = 0;
  if (
    properties &&
    Object.prototype.hasOwnProperty.call(properties, 'dragenter')
  ) {
    rectLeft = properties.left - normalizeValues.width / 2;
    rectTop = properties.top - normalizeValues.height / 2;
  } else if (placing.xOffset || placing.yOffset) {
    rectLeft = placing.xOffset / projectScale;
    rectTop = placing.yOffset / projectScale;
  }
  rect.set({
    left: rectLeft,
    top: rectTop
  });
  const imagePath = dispatch(getElementImagePath(placing));
  fabric.Image.fromURL(imagePath, img => {
    let totalScaleX = normalizeValues.width / img.width;
    let totalScaleY = normalizeValues.height / img.height;

    if (placing.width && placing.height) {
      totalScaleX = placing.width / (img.width * projectScale);
      totalScaleY = placing.height / (img.height * projectScale);
    } else {
      // In case of Unsplash element width and height is not as same as image width and height. Hence recalculating normalize values once image is loaded.

      if (normalizeValues.width > canvas.width) {
        totalScaleX = canvas.width / img.width;
        totalScaleY = totalScaleX;
      }
      if (normalizeValues.height > canvas.height) {
        totalScaleY = canvas.height / img.height;
        totalScaleX = totalScaleY; // (normalizedScaleY * img.height * (img.width / img.height)) / img.width;
      }
    }

    img.set({
      scaleX: totalScaleX,
      scaleY: totalScaleY,
      placing,
      angle: 0,
      opacity: placing.opacity ? placing.opacity : 1,
      flipX: placing.flipX,
      left: rectLeft,
      top: rectTop,
      resizeType: 'proportionally',
      loadingRect: rect,
      layer: Constants.LAYER_ID_ANNOTATION
    });

    if (
      !(
        properties &&
        Object.prototype.hasOwnProperty.call(properties, 'dragenter')
      )
    ) {
      if (!(placing.width && placing.height)) {
        canvas.viewportCenterObject(img);
        if (
          placing.placeableType == Constants.WALL_LAYOUT_KEY &&
          placing.placeable.layoutType == Constants.FURNITURE_TAB_KEY
        ) {
          img.set({ top: canvas.height - img.getScaledHeight() });
        }
      }
    }
    const pixelationIsHidden = dispatch(checkForPixelationWarning(img));
    img.set({
      hasPixelationWarning: pixelationIsHidden
    });
    if (pixelationIsHidden === true) {
      fabric.Object.prototype.set({
        borderColor: 'rgb(253, 136, 54)',
        cornerColor: 'rgb(253, 136, 54)'
      });
    } else {
      fabric.Object.prototype.set({
        cornerColor: 'rgb(128,128,128)',
        borderColor: 'rgb(128,128,128)'
      });
    }
    dispatch(handleRotation(img, placing.angle, canvas));
    dispatch(addCanvasObjectOnCreation(img, canvas));
    dispatch(getDreamstimePrice(placing.placeable));
    if (callback) {
      callback();
    }
  });
};

export const convertToArrayFromColorDict = colorDictArray => {
  const colorsArray = [];
  if (colorDictArray) {
    colorDictArray.forEach(colorDict => {
      colorsArray.push(colorDict.hex);
    });
  }
  return colorsArray;
};

export const convertToDictFromColorArray = colorArray => {
  const colorDictArray = [];
  if (colorArray) {
    colorArray.forEach(color => {
      const dict = {
        hex: color
      };
      colorDictArray.push(dict);
    });
  }
  return colorDictArray;
};

const minimumSceneWidthForProjectWidth = (
  sceneImageWidth,
  sceneImageHeight,
  projectWidth,
  projectHeight
) => dispatch => {
  const aspectRatioOfProject = projectWidth / projectHeight;
  const sceneAspectRatio = sceneImageWidth / sceneImageHeight;

  if (Math.abs(sceneAspectRatio - aspectRatioOfProject) < 0.005) {
    if (sceneAspectRatio >= 1) {
      return (
        dispatch(
          minimumSceneHeightForProjectWidth(
            sceneImageWidth,
            sceneImageHeight,
            projectWidth,
            projectHeight
          )
        ) * Math.max(sceneAspectRatio, aspectRatioOfProject)
      );
    }
    return projectWidth;
  }
  if (sceneAspectRatio > aspectRatioOfProject) {
    return (
      dispatch(
        minimumSceneHeightForProjectWidth(
          sceneImageWidth,
          sceneImageHeight,
          projectWidth,
          projectHeight
        )
      ) * sceneAspectRatio
    );
  }
  return projectWidth;
};

const minimumSceneHeightForProjectWidth = (
  sceneImageWidth,
  sceneImageHeight,
  projectWidth,
  projectHeight
) => dispatch => {
  const aspectRatioOfProject = projectWidth / projectHeight;
  const sceneAspectRatio = sceneImageWidth / sceneImageHeight;
  if (Math.abs(sceneAspectRatio - aspectRatioOfProject) < 0.005) {
    if (sceneAspectRatio >= 1) {
      return projectHeight;
    }
    return (
      dispatch(
        minimumSceneWidthForProjectWidth(
          sceneImageWidth,
          sceneImageHeight,
          projectWidth,
          projectHeight
        )
      ) * Math.max(sceneAspectRatio, aspectRatioOfProject)
    );
  }
  if (sceneAspectRatio > aspectRatioOfProject) {
    return projectHeight;
  }
  return (
    dispatch(
      minimumSceneWidthForProjectWidth(
        sceneImageWidth,
        sceneImageHeight,
        projectWidth,
        projectHeight
      )
    ) / sceneAspectRatio
  );
};

export const minimumSceneWidth = (sceneImageWidth, sceneImageHeight) => (
  dispatch,
  getState
) => {
  const scenePaddingValue = dispatch(scenePadding());
  const { projectWidth, projectHeight } = getState().home;

  if (!dispatch(isSharedScene())) {
    return dispatch(
      minimumSceneWidthForProjectWidth(
        sceneImageWidth,
        sceneImageHeight,
        projectWidth + scenePaddingValue,
        projectHeight + scenePaddingValue
      )
    );
  }
  const totalWidth = dispatch(getMultiProjectsWidth()) + scenePaddingValue;
  return dispatch(
    minimumSceneWidthForProjectWidth(
      sceneImageWidth,
      sceneImageHeight,
      totalWidth,
      projectHeight + scenePaddingValue
    )
  );
};

export const minimumSceneHeight = (sceneImageWidth, sceneImageHeight) => (
  dispatch,
  getState
) => {
  const scenePaddingValue = dispatch(scenePadding());
  const { projectWidth, projectHeight } = getState().home;

  if (!dispatch(isSharedScene())) {
    return dispatch(
      minimumSceneHeightForProjectWidth(
        sceneImageWidth,
        sceneImageHeight,
        projectWidth + scenePaddingValue,
        projectHeight + scenePaddingValue
      )
    );
  }
  const totalWidth = dispatch(getMultiProjectsWidth()) + scenePaddingValue;
  return dispatch(
    minimumSceneHeightForProjectWidth(
      sceneImageWidth,
      sceneImageHeight,
      totalWidth,
      projectHeight + scenePaddingValue
    )
  );
};

export const prepareTextRequest = array => {
  const placeablesArray = [];

  array.forEach(placing => {
    const { placeable } = placing;
    let textColor = placeable.rgb;
    if (textColor.substr(0, 1) == '#') textColor = textColor.substr(1);
    let { shadowColor } = placeable;
    if (shadowColor.substr(0, 1) == '#') shadowColor = shadowColor.substr(1);
    const postData = {
      placeable: {
        id: placeable.id,
        text_color: textColor,
        text: placeable.text,
        text_anchor: placeable.textAnchor,
        font_id: placeable.fontId,
        path: placeable.textPath
      }
    };
    if (placeable.shadow) {
      postData.placeable.shadow = true;
      postData.placeable.shadow_color = shadowColor;
    } else {
      postData.placeable.shadow = false;
    }
    placeablesArray.push(postData);
  });
  return { placeables: placeablesArray, require_web_image: true };
};

export const saveText = callback => (dispatch, getState) => {
  const { project } = getState().finalCheck;
  const nonsavedTextObjects = [];
  getPlacings(project).forEach(placing => {
    if (
      placing.placeableType === Constants.TEXT_ELEMENT_TYPE &&
      !placing.placeable.id
    ) {
      nonsavedTextObjects.push(placing);
    }
  });

  if (nonsavedTextObjects.length > 0) {
    const textSaveCheckTImer = setInterval(() => {
      const totalCount = nonsavedTextObjects.length;
      let counter = 0;
      nonsavedTextObjects.forEach(placing => {
        if (placing.placeable.id) {
          counter++;
          if (counter == totalCount) {
            clearInterval(textSaveCheckTImer);
            callback();
          }
        }
      });
    }, 2000);
  } else {
    callback();
  }
};

export const createNewTextIfFromInspirations = callback => (
  dispatch,
  getState
) => {
  const { project } = getState().finalCheck;
  const textPlacings = [];
  getPlacings(project).forEach(placing => {
    if (
      placing.placeableType === Constants.TEXT_ELEMENT_TYPE &&
      !placing.placeable.id
    ) {
      textPlacings.push(placing);
    }
  });

  if (textPlacings.length > 0) {
    const requestData = prepareTextRequest(textPlacings);
    api.sendMultipleAddText(requestData).then(postResponse => {
      const textArray = createResponseObject(
        postResponse.data,
        Constants.TEXT_ELEMENT_TYPE
      );
      textPlacings.forEach((textPlacing, i) => {
        textPlacing.placeable = textArray[i];
        textPlacing.placeableId = textArray[i].id;
      });
      callback();
    });
  } else {
    callback();
  }
};

export const getStartupScenePlacing = () => (dispatch, getState) => {
  let startUpSceneObj = getState().modal.startUpScene;
  startUpSceneObj.externalPlaceable = false;
  if (dispatch(shouldSelectFirstSceneOfFirstTheme())) {
    const firstTheme = dispatch(getFirstTheme());
    if (firstTheme) {
      [startUpSceneObj] = firstTheme.elements;
      startUpSceneObj.themeId = firstTheme.id;
    }
  }
  const placing = new Placing(startUpSceneObj);
  placing.storeId = getState().modal.storeData.id;
  placing.width = startUpSceneObj.width;
  placing.height = startUpSceneObj.height;
  placing.id = null;
  return placing;
};

export const handleInitialPopup = () => (dispatch, getState) => {
  const { envData } = getState().modal;
  const { storeData } = getState().modal;
  dispatch(sendDesignPageGAEvents());

  if (envData.is_vanilla_designer) {
    if (storeData.hasLitePartnerPrinter) {
      if (!localStorage.getItem('showHelpWindow')) {
        dispatch(showHelperWindow(true));
      }
    } else {
      dispatch(getPrintersDetails());
      dispatch(handleAddPrinterWindow(true));
    }
  } else if (!localStorage.getItem('showHelpWindow')) {
    dispatch(showHelperWindow(true));
  }
};

export const prepareInspirationForSave = () => (dispatch, getState) => {
  const { project } = getState().finalCheck;
  project.parentId = project.id;
  project.projectGroupId = null;
  project.externalId = null;
  project.id = null;
  project.token = null;
  project.state = Constants.EDITING_STATE;
  project.walls.forEach(wall => {
    wall.id = null;
  });
  project.activeWall.id = null;
  const allPlacings = getPlacings(project);
  allPlacings.forEach(placing => {
    if (isElementRecolorable(placing)) {
      placing.placeable.clonable = true;
    } else if (placing.placeableType === Constants.TEXT_ELEMENT_TYPE) {
      placing.placeable.id = null;
      placing.placeableId = null;
    }
    placing.id = null;
    placing.wallId = null;
  });
  dispatch(gaOfSelectingInspiration());
};

// LoadInspiration from react_canvas
export const loadProjectCanvas = (
  project,
  isInspiration,
  isOnlyFetchPlaceables
) => dispatch => {
  dispatch(clearCanvas());

  if (!isOnlyFetchPlaceables) {
    if (isInspiration) {
      dispatch(setLoadingState(string.LOADING_TEMPLATE_KEY));
    } else {
      dispatch(setLoadingState(string.LOADING_KEY));
    }
  }
  return dispatch(
    fetchWallLayoutDetails(project, isInspiration, isOnlyFetchPlaceables)
  );
};

export const fetchWallLayoutDetails = (
  project,
  isInspiration,
  isOnlyFetchPlaceables
) => (dispatch, getState) =>
  new Promise(resolve => {
    dispatch(setNoContentResourcePrefix());
    let wallLayoutsCounter = 0;
    if (project.activeWall.placings.length > 0) {
      project.activeWall.placings.forEach(wallPlacing => {
        api
          .fetchWallLayout(
            wallPlacing.placeableId,
            project.storeId,
            getState().modal.storeData.cacheTimestamp
          )
          .then(responseData => {
            wallLayoutsCounter++;
            const placeable = createResponseObject(
              [responseData.data],
              wallPlacing.placeableType
            )[0];
            wallPlacing.placeable = placeable;
            copyPlaceable(wallPlacing, placeable);
            if (wallLayoutsCounter == project.activeWall.placings.length) {
              dispatch(
                fetchPlaceableDetails(
                  project,
                  isInspiration,
                  isOnlyFetchPlaceables
                )
              ).then(resolve);
            }
          });
      });
    } else {
      dispatch(
        fetchPlaceableDetails(project, isInspiration, isOnlyFetchPlaceables)
      ).then(resolve);
    }
  });

export const fetchPlaceableDetails = (
  project,
  isInspiration,
  isOnlyFetchPlaceables
) => (dispatch, getState) =>
  new Promise(resolve => {
    const placingsWithoutStartupScene = [];
    const startUpSceneObj = getState().modal.startUpScene;

    project.scenePlacings.forEach(placing => {
      if (dispatch(isStartUpScene(placing))) {
        placing.placeable = startUpSceneObj;
      } else {
        placingsWithoutStartupScene.push(placing);
      }
    });
    project.elementPlacings.forEach(elementPlacing => {
      placingsWithoutStartupScene.push(elementPlacing);
    });
    if (placingsWithoutStartupScene.length === 0) {
      dispatch(
        continueWithLoadCanvas(project, isInspiration, isOnlyFetchPlaceables)
      ).then(resolve);
      dispatch(setLoadingState(null));
      return;
    }

    const nonUserPhotoList = placingsWithoutStartupScene.filter(
      placing =>
        placing.placeableType !== Constants.TEXT_ELEMENT_TYPE &&
        placing.placeableType !== Constants.USER_PHOTO_TYPE
    );
    if (nonUserPhotoList.length > 0) {
      dispatch(
        fetchNonUserPhotoDetails(
          project,
          isInspiration,
          isOnlyFetchPlaceables,
          placingsWithoutStartupScene,
          nonUserPhotoList
        )
      ).then(resolve);
    } else {
      dispatch(
        continueFetchUserPhotoDetails(
          project,
          isInspiration,
          isOnlyFetchPlaceables,
          placingsWithoutStartupScene
        )
      ).then(resolve);
    }
  });

const allPlacebalesFetched = project => {
  for (let i = 0; i < project.scenePlacings.length; i++) {
    const placing = project.scenePlacings[i];
    if (!placing.placeable) {
      return false;
    }
  }
  for (let i = 0; i < project.elementPlacings.length; i++) {
    const placing = project.elementPlacings[i];
    if (!placing.placeable) {
      return false;
    }
  }
  return true;
};

const fetchNonUserPhotoDetails = (
  project,
  isInspiration,
  isOnlyFetchPlaceables,
  placingsWithoutStartupScene,
  nonUserPhotoList
) => (dispatch, getState) =>
  new Promise(resolve => {
    let nonUserPhotoCounter = 0;
    placingsWithoutStartupScene.forEach(placing => {
      if (
        placing.placeableType !== Constants.USER_PHOTO_TYPE &&
        placing.placeableType !== Constants.TEXT_ELEMENT_TYPE
      ) {
        if (placing.externalPlaceable) {
          dispatch(setExternalContentResourcePrefix());
        } else {
          dispatch(setInternalContentResourcePrefix());
        }
        api
          .fetchPlaceableDetails(
            placing.themeId,
            placing.placeableType,
            placing.placeableId,
            project.storeId,
            isInspiration,
            getState().modal.storeData.cacheTimestamp
          )

          .then(responseData => {
            const placeable = createResponseObject(
              [responseData.data],
              placing.placeableType
            )[0];
            placing.placeable = placeable;
            copyPlaceable(placing, placeable);
            nonUserPhotoCounter++;
            if (nonUserPhotoList.length === nonUserPhotoCounter) {
              if (allPlacebalesFetched(project)) {
                dispatch(
                  continueWithLoadCanvas(
                    project,
                    isInspiration,
                    isOnlyFetchPlaceables
                  )
                ).then(resolve);
              } else {
                dispatch(
                  continueFetchUserPhotoDetails(
                    project,
                    isInspiration,
                    isOnlyFetchPlaceables,
                    placingsWithoutStartupScene
                  )
                ).then(resolve);
              }
            }
          })
          .catch(() => {
            dispatch(setLoadingState(null));
          });
      }
    });
  });

const preparePlacingListStoreWise = placingList => {
  const idsDict = {};

  const placingStoreIds = [];
  placingList.map(placing => placingStoreIds.push(placing.storeId));
  const uniquePlacingStoreIds = uniqueArray(placingStoreIds);

  uniquePlacingStoreIds.forEach(placingStoreId => {
    const idList = [];
    const placingsOfSameStore = [
      ...placingList.filter(placing => placing.storeId === placingStoreId)
    ];
    placingsOfSameStore.forEach(placing => {
      idList.push(placing);
    });
    idsDict[placingStoreId] = idList;
  });
  return idsDict;
};

const continueFetchUserPhotoDetails = (
  project,
  isInspiration,
  isOnlyFetchPlaceables,
  placingsWithoutStartupScene
) => dispatch =>
  new Promise(resolve => {
    placingsWithoutStartupScene.map(placing => {
      if (!placing.storeId) {
        placing.storeId = project.storeId;
      }
    });
    const userPhotoList = placingsWithoutStartupScene.filter(
      placing => placing.placeableType === Constants.USER_PHOTO_TYPE
    );
    const textElementsList = placingsWithoutStartupScene.filter(
      placing => placing.placeableType === Constants.TEXT_ELEMENT_TYPE
    );

    if (userPhotoList.length > 0) {
      const placingStoreDict = preparePlacingListStoreWise(userPhotoList);
      dispatch(
        sendRequestInList(
          project,
          Constants.USER_PHOTO_TYPE,
          placingStoreDict,
          isInspiration,
          isOnlyFetchPlaceables
        )
      ).then(resolve);
    }

    if (textElementsList.length > 0) {
      const placingStoreDict = preparePlacingListStoreWise(textElementsList);
      dispatch(
        sendRequestInList(
          project,
          Constants.TEXT_ELEMENT_TYPE,
          placingStoreDict,
          isInspiration,
          isOnlyFetchPlaceables
        )
      ).then(resolve);
    }
  });

export const sendRequestInList = (
  project,
  placeableType,
  placingStoreDict,
  isInspiration,
  isOnlyFetchPlaceables
) => (dispatch, getState) =>
  new Promise(resolve => {
    dispatch(setInternalContentResourcePrefix());

    dispatch(
      fetchUserPhotoDetailsOfRespectiveStore(
        placeableType,
        placingStoreDict,
        isInspiration
      )
    ).then(responseArray => {
      let allPlacings = [];
      const allKeys = Object.keys(placingStoreDict);
      allKeys.forEach(key => {
        if (Object.prototype.hasOwnProperty.call(placingStoreDict, key)) {
          const placings = placingStoreDict[key];
          allPlacings = allPlacings.concat(placings);
        }
      });
      // forEach doesnt break the loop hence using for
      for (let i = 0; i < allPlacings.length; i++) {
        const placing = allPlacings[i];
        const userPhotoResponseDetails = {
          ...responseArray.filter(
            userPhotoResponse => placing.placeableId == userPhotoResponse.id
          )[0]
        };

        const matchedPlacings = allPlacings.filter(
          p => p.placeableId == userPhotoResponseDetails.id
        );

        const userPhotoObj = createResponseObject(
          [userPhotoResponseDetails],
          placing.placeableType,
          userPhotoResponseDetails.image_source
        )[0];
        matchedPlacings.forEach(matchedPlacing => {
          matchedPlacing.placeable = userPhotoObj;
          copyPlaceable(matchedPlacing, userPhotoObj);
        });
        if (
          userPhotoObj.imageSource === Constants.LOCAL_IMAGE_SOURCE ||
          userPhotoObj.imageSource === Constants.DROPBOX_IMAGE_SOURCE ||
          userPhotoObj.imageSource === Constants.INSTAGRAM_IMAGE_SOURCE
        ) {
          const contents = getState().sideBar.uploadInfo.uploadArray;
          if (contents.filter(obj => obj.id == userPhotoObj.id).length <= 0) {
            contents.push(userPhotoObj);
            dispatch({
              type: actions.SET_UPLOAD_CONTENTS,
              payload: {
                uploadArray: contents
              }
            });
          }
        }
        if (allPlacebalesFetched(project)) {
          dispatch(
            continueWithLoadCanvas(
              project,
              isInspiration,
              isOnlyFetchPlaceables
            )
          ).then(resolve);
          break;
        }
      }
    });
  });

export const fetchUserPhotoDetailsOfRespectiveStore = (
  placeableType,
  placingStoreDict,
  isInspiration
) => (dispatch, getState) =>
  new Promise(resolve => {
    let allResponseData = [];
    let counter = 0;

    const allKeys = Object.keys(placingStoreDict);
    allKeys.forEach(key => {
      if (Object.prototype.hasOwnProperty.call(placingStoreDict, key)) {
        const placingsList = placingStoreDict[key];
        const idsList = placingsList.map(placing => placing.placeableId);
        // If User photo list request has duplicate ids response will remove those duplicate id response.
        const uniqueIdList = uniqueArray(idsList);
        api
          .fetchUserPhotoDetails(
            convertFromCamelCase(placeableType),
            uniqueIdList.toString(),
            getState().modal.envData.store_id,
            key,
            isInspiration,
            getState().modal.storeData.cacheTimestamp
          )
          .then(responseData => {
            counter++;
            allResponseData = allResponseData.concat([...responseData.data]);
            if (counter === Object.keys(placingStoreDict).length) {
              resolve(allResponseData);
            }
          });
      }
    });
  });

export const sortBasedOnZIndex = inArray => {
  inArray.sort((a, b) => a.zIndex - b.zIndex);
};

export const continueWithLoadCanvas = (
  project,
  isInspiration,
  isOnlyFetchPlaceables
) => (dispatch, getState) =>
  new Promise(resolve => {
    dispatch(setNoContentResourcePrefix());
    if (isOnlyFetchPlaceables) return;
    if (isInspiration) dispatch(prepareInspirationForSave());
    const textPlaceables = [];
    project.elementPlacings.forEach(placing => {
      if (placing.placeableType === Constants.TEXT_ELEMENT_TYPE) {
        textPlaceables.push(placing.placeable);
      }
    });
    dispatch(getTextFonts(textPlaceables));

    // In case of switching to Model page and coming back to Design page project should be retained in case of wallart products.
    // Project is holding placing values wrt that project size. But In model page user can change project size.
    // Hence backup user selected project size(wall size) and load project first wrt that project size. Then apply user selected wall size

    const { activeWall } = getState().finalCheck.project;
    const { projectWidth, projectHeight } = getState().home;
    let bakupProjectWidth = projectWidth;
    let backupProjectHeight = projectHeight;
    if (
      isInspiration ||
      (projectWidth == project.width && projectHeight == project.height)
    ) {
      bakupProjectWidth = null;
      backupProjectHeight = null;
    }
    dispatch({
      type: actions.SET_BACKUP_PROJECT_SIZE,
      payload: { width: bakupProjectWidth, height: backupProjectHeight }
    });

    if (!dispatch(checkIfCanvasApp())) {
      activeWall.width = project.width;
      activeWall.height = project.height;
    }
    const { width, height, canvasRowsCount, canvasColumnsCount } = project;
    dispatch(
      sizeSettingsAreChanged(
        width,
        height,
        canvasRowsCount,
        canvasColumnsCount,
        activeWall.width,
        activeWall.height
      )
    );
    const { dimensions, wallCanvas } = getState().fabricCanvas;

    dispatch(
      updateWindowDimensions(
        dimensions.orgWindowWidth,
        dimensions.orgWindowHeight
      )
    ).then(() => {
      wallCanvas.setHeight(dimensions.projectScaleHeight);
      wallCanvas.setWidth(dimensions.projectScaleWidth);
      wallCanvas.setDimensions(
        {
          width: project.activeWall.width,
          height: project.activeWall.height
        },
        {
          cssOnly: true
        }
      );

      const currentWallScenePlacings = project.scenePlacings.filter(
        placing => placing.wallIndex == project.wallIndex
      );
      const currentWallElementPlacings = project.elementPlacings.filter(
        placing => placing.wallIndex == project.wallIndex
      );

      let totalLoadableContentsCount =
        currentWallElementPlacings.length + project.activeWall.placings.length;
      let loadContentsCounter = 0;

      project.activeWall.placings.forEach(placing => {
        dispatch(
          addElementToCanvas(placing, 0, () => {
            loadContentsCounter++;
            dispatch(
              checkIfAllProjectContentsLoadedAndSwitchToSelectedWall(
                loadContentsCounter,
                totalLoadableContentsCount
              )
            ).then(resolve);
          })
        );
      });

      if (project.backgroundColor) {
        dispatch(addSolidColorToCanvas(project.backgroundColor));
        dispatch(
          checkIfAllProjectContentsLoadedAndSwitchToSelectedWall(
            loadContentsCounter,
            totalLoadableContentsCount
          )
        ).then(resolve);
      } else {
        currentWallScenePlacings.forEach(placing => {
          if (!dispatch(isStartUpScene(placing))) {
            totalLoadableContentsCount++;
            dispatch(
              addBackgroundToCanvas(placing, 0, () => {
                loadContentsCounter++;
                dispatch(
                  checkIfAllProjectContentsLoadedAndSwitchToSelectedWall(
                    loadContentsCounter,
                    totalLoadableContentsCount
                  )
                ).then(resolve);
              })
            );
          }
        });
      }
      sortBasedOnZIndex(currentWallElementPlacings);
      currentWallElementPlacings.forEach(placing => {
        if (placing.placeableType === Constants.TEXT_ELEMENT_TYPE) {
          dispatch(
            textImageIsGenerated(placing, false, () => {
              loadContentsCounter++;
              dispatch(
                checkIfAllProjectContentsLoadedAndSwitchToSelectedWall(
                  loadContentsCounter,
                  totalLoadableContentsCount
                )
              ).then(resolve);
            })
          );
        } else {
          dispatch(
            addElementToCanvas(placing, {}, () => {
              loadContentsCounter++;
              dispatch(
                checkIfAllProjectContentsLoadedAndSwitchToSelectedWall(
                  loadContentsCounter,
                  totalLoadableContentsCount
                )
              ).then(resolve);
            })
          );
        }
      });
      dispatch(
        checkIfAllProjectContentsLoadedAndSwitchToSelectedWall(
          loadContentsCounter,
          totalLoadableContentsCount
        )
      ).then(resolve);
    });
  });

const checkIfAllProjectContentsLoadedAndSwitchToSelectedWall = (
  loadContentsCounter,
  totalLoadableContentsCount
) => (dispatch, getState) =>
  new Promise(resolve => {
    if (loadContentsCounter == totalLoadableContentsCount) {
      dispatch(
        createNewTextIfFromInspirations(() => {
          dispatch(setLoadingState(null));
          const { project } = getState().finalCheck;
          const { backupProjectSize } = getState().home;
          if (
            project.activeWall &&
            backupProjectSize.width &&
            backupProjectSize.height
          ) {
            if (!dispatch(checkIfCanvasApp())) {
              project.activeWall.width = backupProjectSize.width;
              project.activeWall.height = backupProjectSize.height;
            }
            dispatch(
              sizeSettingsAreChanged(
                backupProjectSize.width,
                backupProjectSize.height,
                project.canvasRowsCount,
                project.canvasColumnsCount,
                project.activeWall.width,
                project.activeWall.height
              )
            );
            dispatch(makeProjectDirtyWithNoUndoSupport(true));
          } else {
            dispatch(clearUndoInstance());
          }
          dispatch(loadingProjectJSONToCanvasIsCompleted());
          resolve();
        })
      );
    }
  });

const loadingProjectJSONToCanvasIsCompleted = () => (dispatch, getState) => {
  const { project, multiWallProjects } = getState().finalCheck;
  dispatch(selectObject(null));
  dispatch(minimumViewingDistanceIsUpdated());
  if (multiWallProjects.length > 1) dispatch(generatePreviewsOfSideWalls());
  const cookie = CookieUtils.resumeActivityCookieActivity();
  if (
    cookie === Constants.LITE_SAVE_ACTIVITY &&
    getState().modal.envData.is_lite_patner
  ) {
    dispatch(sendLoginGAEvents(Constants.GA_EVENT_ACTIONS.AFTER_LOGIN));
    dispatch(retriveDocumentColorsFromCookies());
    dispatch(saveProjectAndCall());
  } else if (
    cookie === Constants.LITE_CHECKOUT_ACTIVITY &&
    getState().modal.envData.is_lite_patner
  ) {
    if (getState().modal.storeData.hasLitePartnerPrinter) {
      dispatch(setCurrentPageIndex(Constants.FINAL_CHECK_PAGE));
    }
    dispatch(sendLoginGAEvents(Constants.GA_EVENT_ACTIONS.AFTER_LOGIN));
    dispatch(retriveDocumentColorsFromCookies());
    dispatch(saveProjectAndCall());
  } else if (cookie === Constants.WEBLINK_CHECKOUT_ACTIVITY) {
    dispatch(setWebLinkSaveIdentifier(Constants.FINAL_CHECK_KEY));
    dispatch(sendLoginGAEvents(Constants.GA_EVENT_ACTIONS.AFTER_WEBLINK_LOGIN));
    dispatch(retriveDocumentColorsFromCookies());
    dispatch(
      saveOnlyIfDirtyAndCall().then(() => {
        dispatch(setCurrentPageIndex(Constants.FINAL_CHECK_PAGE));
      })
    );
  } else if (cookie === Constants.WEBLINK_SAVE_ACTIVITY) {
    dispatch(setWebLinkSaveIdentifier(Constants.DESIGN_KEY));
    dispatch(sendLoginGAEvents(Constants.GA_EVENT_ACTIONS.AFTER_WEBLINK_LOGIN));
    dispatch(retriveDocumentColorsFromCookies());
  } else if (isLaunchToProcessingPageEnabled()) {
    dispatch(saveProjectAndCall());
    dispatch(setCurrentPageIndex(Constants.FINAL_CHECK_PAGE));
  } else if (isLaunchToCheckoutEnabled()) {
    dispatch(setCurrentPageIndex(Constants.FINAL_CHECK_PAGE));
    api.getShippingDetails(project.token).then(response => {
      project.extraInfo = project.additionalPrintingInstruction;
      dispatch(updateFinalCheckWithData(response.data));
    });
  }
  if (
    getState().modal.envData.is_vanilla_designer &&
    !getState().modal.storeData.hasLitePartnerPrinter
  ) {
    dispatch(getPrintersDetails());
    dispatch(handleAddPrinterWindow(true));
  }
};

// Order sample and email actions
export const sendEmailToRecipients = (recipientList, aMessage, aName) => (
  dispatch,
  getState
) => {
  const { sendPreviewWithLoupe } = getState().fabricCanvas;
  let newMessage = aMessage;
  let newName = aName;
  if (sendPreviewWithLoupe) {
    newMessage = getUrlSafeStringFromString(aMessage);
    newName = getUrlSafeStringFromString(aName);
    const xOffset = getState().fabricCanvas.orderSampleDetails.lastX;
    const yOffset = getState().fabricCanvas.orderSampleDetails.lastY;
    const sampleSize = dispatch(sampleModelSize());
    const scale =
      getState().home.projectHeight / getState().fabricCanvas.wallCanvas.height;

    const JSONString = {
      name: newName,
      x_offset: xOffset * scale,
      y_offset: yOffset * scale,
      width: sampleSize.width,
      height: sampleSize.height
    };

    emailPreviewWithLoupeRecipients(
      recipientList,
      newMessage,
      JSONString,
      dispatch,
      getState
    );
  } else {
    const { shareLinkType } = getState().fabricCanvas;

    emailRecipientsWithMessageAboutProjectLinkType(
      recipientList,
      newMessage,
      shareLinkType,
      dispatch,
      getState
    );
  }
};

export const getUrlSafeStringFromString = aString => {
  if (aString) {
    const tempStr = aString.replace(/"\"/g, '\\"');
    return encodeURIComponent(tempStr);
  }
  return '';
};

export const isValidEmailAddress = anEmailAddress => {
  let valid = false;
  if (
    anEmailAddress !== null &&
    anEmailAddress.length !== 0 &&
    anEmailAddress.split('@').length === 2
  ) {
    const emailReg = new RegExp(
      '^([\\w\\.%\\+\\-]+)@([\\w\\-]+\\.)+([\\w]{2,})$',
      'i'
    );
    valid = anEmailAddress.match(emailReg) != null;
  }
  return valid;
};

export const backgroundElement = canvas => {
  if (canvas) {
    const canvasObjects = canvas.getObjects();
    const filteredObjects = canvasObjects.filter(e => isBackground(e));
    if (filteredObjects.length > 0) {
      return filteredObjects[0];
    }
  }
  return null;
};

export const canvasElementsExceptBackground = canvas => {
  const canvasObjects = canvas.getObjects();
  return canvasObjects.filter(e => !isBackground(e));
};

export const isImageBasedBackground = element =>
  element &&
  Object.prototype.hasOwnProperty.call(element, 'placing') &&
  (element.placing.placeableType === Constants.SCENE_KEY ||
    (element.placing.placeableType === Constants.USER_PHOTO_TYPE &&
      element.placing.userPhotoType === Constants.USER_PHOTO_SCENE_TYPE));

export const isBackground = element =>
  element &&
  Object.prototype.hasOwnProperty.call(element, 'placing') &&
  (isImageBasedBackground(element) ||
    element.placing.placeableType === Constants.SOLID_FILL_KEY);

export const isSolidFillBackground = ele =>
  ele &&
  Object.prototype.hasOwnProperty.call(ele, 'placing') &&
  ele.placing.placeableType === Constants.SOLID_FILL_KEY;

export const isFurnitureLayout = element =>
  element &&
  Object.prototype.hasOwnProperty.call(element, 'placing') &&
  element.placing.placeableType === Constants.WALL_LAYOUT_KEY &&
  element.placing.placeable.layoutType == Constants.FURNITURE_TAB_KEY;

export const isWallLayout = element =>
  element &&
  Object.prototype.hasOwnProperty.call(element, 'placing') &&
  element.placing.placeableType === Constants.WALL_LAYOUT_KEY;

export const isAnnotationLayer = element => !isBackground(element);

export const canDuplicateElement = element =>
  !isBackground(element) && !isWallLayout(element);

export const retriveDocumentColorsFromCookies = () => dispatch => {
  const colors = CookieUtils.resumeDocumentColorsCookieActivity();
  if (colors !== null) {
    dispatch({
      type: actions.SET_DOCUMENT_COLORS,
      payload: {
        documentColors: colors
      }
    });
  }
};

export const redrawScene = () => (dispatch, getState) => {
  const { wallCanvas } = getState().fabricCanvas;
  const backgroundEle = backgroundElement(wallCanvas);
  if (backgroundEle && isImageBasedBackground(backgroundEle)) {
    const { placing } = backgroundEle;
    dispatch(setScenePlacingOffsetAndSize(placing));
    dispatch(removeElement(backgroundEle));
    dispatch(addBackgroundToCanvas(placing, 0, () => {}));
  }
};
